import { ActionTypeCreator } from 'app-webtech-core/actions/actionType';

const ActionType = new ActionTypeCreator('PLAYER');

export const AUTOSTART_NOT_ALLOWED = ActionType.simple('AUTOSTART_NOT_ALLOWED');
export const LOAD = ActionType.simple('LOAD');
export const PLAY = ActionType.simple('PLAY');
export const PAUSE = ActionType.simple('PAUSE');
export const TIME = ActionType.simple('TIME');
export const SEEK = ActionType.simple('SEEK');
export const STOP = ActionType.simple('STOP');
export const END = ActionType.simple('END');
export const VOLUME = ActionType.simple('VOLUME');
export const SET_ERROR = ActionType.simple('SET_ERROR');
export const CLEAR_ERROR = ActionType.simple('CLEAR_ERROR');
export const START_BUFFERING = ActionType.simple('START_BUFFERING');
export const END_BUFFERING = ActionType.simple('END_BUFFERING');
export const SET_INFO_BANNER = ActionType.simple('SET_INFO_BANNER');
export const ENTERED_FULLSCREEN = ActionType.simple('ENTERED_FULLSCREEN');
export const EXITED_FULLSCREEN = ActionType.simple('EXITED_FULLSCREEN');
export const EPISODE_STARTS = ActionType.simple('EPISODE_STARTS');
export const EPISODE_ENDS = ActionType.simple('EPISODE_ENDS');
export const CLIP_STARTS = ActionType.simple('CLIP_STARTS');
export const CLIP_ENDS = ActionType.simple('CLIP_ENDS');
export const MUTE = ActionType.simple('MUTE');
export const UNMUTE = ActionType.simple('UNMUTE');
export const VOLUME_CHANGE = ActionType.simple('VOLUME_CHANGE');
export const SET_IS_VIDEO_REQUESTED = ActionType.simple('SET_IS_VIDEO_REQUESTED');
export const VIDEO_LOADED = ActionType.simple('VIDEO_LOADED');
// Duplicated event just for BI purposes. It doesn't mean the same as our VIDEO_LOADED.
export const VIDEO_LOADED_FOR_BI = ActionType.simple('VIDEO_LOADED_FOR_BI');
export const VIDEO_BIT_RATE_CHANGE = ActionType.simple('VIDEO_BIT_RATE_CHANGE');
export const SHOW_VIDEO_CONTROLS = ActionType.simple('SHOW_VIDEO_CONTROLS');
export const HIDE_VIDEO_CONTROLS = ActionType.simple('HIDE_VIDEO_CONTROLS');
export const VOLUME_CHANGE_NO_BEACON = ActionType.simple('VOLUME_CHANGE_NO_BEACON');
export const CLICK_PLAY = ActionType.simple('CLICK_PLAY');
export const CLICK_PAUSE = ActionType.simple('CLICK_PAUSE');
export const CC_MENU_OPEN = ActionType.simple('CC_MENU_OPEN');
export const CC_MENU_CLOSE = ActionType.simple('CC_MENU_CLOSE');
export const CC_MENU_RESET = ActionType.simple('CC_MENU_RESET');
export const CC_NEXT_SUBMENU = ActionType.simple('CC_NEXT_SUBMENU');
export const CC_PREV_SUBMENU = ActionType.simple('CC_PREV_SUBMENU');
export const CC_INDEX_CHANGE = ActionType.simple('CC_INDEX_CHANGE');
export const CC_INDEX_SET = ActionType.simple('CC_INDEX_SET');
